(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9487],{

/***/ 69928:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/t",
      function () {
        return __webpack_require__(84050);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85657:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ event; }
/* harmony export */ });
/* unused harmony exports GA_TRACKING_ID, pageview */
var GA_TRACKING_ID = (/* unused pure expression or super */ null && ("G-11BQSE72VC"));
// https://developers.google.com/analytics/devguides/collection/gtagjs/pages
var pageview = function(url) {
    window.gtag("config", GA_TRACKING_ID, {
        page_path: url
    });
};
// log specific events happening.
var event = function(param) {
    var action = param.action, params = param.params;
    window.gtag("event", action, params);
};


/***/ }),

/***/ 84050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/utils.ts
var utils = __webpack_require__(90759);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 6 modules
var useCookies = __webpack_require__(70461);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./lib/gtag.ts
var gtag = __webpack_require__(85657);
;// CONCATENATED MODULE: ./components/customer/TrackingView.tsx







var TrackingView = function(props) {
    var getDoctorStatus = function getDoctorStatus() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                clientStatus != "active" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-secondary fs-5 pb-4 fw-semibold",
                        children: "\uD83D\uDD34\xa0 Doctor hasn't arrived yet."
                    })
                }),
                clientStatus == "active" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-secondary fs-5 pb-4 fw-semibold",
                    children: "\uD83D\uDFE2\xa0 Doctor is attending to the patients."
                })
            ]
        });
    };
    var getTrackingView = function getTrackingView() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                tokenNumber && tokenNumber != currentTokenNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "text-info",
                            children: businessName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col col-12 pt-4 pb-2 fs-5 text-left",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-muted",
                                        children: "Doctor:"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-info",
                                        children: clientName
                                    })
                                ]
                            })
                        }),
                        isForToday && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: getDoctorStatus()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-muted fs-5",
                                        children: "Patient Name:\xa0\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fs-5",
                                        children: name
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-muted fs-5",
                                        children: " Token:\xa0\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fs-5",
                                        children: tokenNumber
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "d-flex gap-1",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-muted fs-5",
                                        children: "Patients Ahead:\xa0\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "fs-5",
                                        children: waitingAhead
                                    })
                                ]
                            })
                        }),
                        !isForToday && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "py-2",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "d-flex gap-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-muted fs-5",
                                            children: "Appointment Date:\xa0\xa0"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "fs-5",
                                            children: consultDate
                                        })
                                    ]
                                })
                            })
                        }),
                        sessionDisplay && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-2",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-muted fs-5 d-inline-block",
                                    children: "Session Timing:\xa0\xa0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-5 d-inline-block",
                                    children: sessionDisplay
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-4",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-muted fs-5 d-inline-block",
                                    children: "Estimated Consultation Time Between:\xa0\xa0"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "fs-3 d-inline-block text-success",
                                    children: consultationTime
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "pt-3 text-danger ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "card p-3",
                                        children: [
                                            "* This is indicative time only and is NOT A GUARANTEE.",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "* Please reach 15 minutes prior to your indicative time."
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "py-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "btn btn-info text-white",
                                type: "button",
                                onClick: handleRequest,
                                disabled: props.trackingId == null,
                                children: " ↺ Refresh"
                            })
                        })
                    ]
                }),
                tokenNumber && tokenNumber == currentTokenNumber && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-3 fs-3 text-warning",
                            children: [
                                "Hey ",
                                name
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "fs-1 bg-success text-light p-4",
                            children: "It's time. Please proceed to the doctor."
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fs-6 text-black pt-3 mt-3",
                            children: [
                                "Visit ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://qme.co.in",
                                    children: "www.qme.co.in"
                                }),
                                " for online appointment next time"
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "my-3 text-danger fs-3",
                            children: error
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "fs-6 text-black pt-3 mt-3",
                            children: [
                                "For taking appointment again, please visit ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    href: "https://qme.co.in",
                                    children: "www.qme.co.in"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCookies/* default */.Z)([
        "qme_customer"
    ]), 2), cookies = ref[0], setCookie = ref[1];
    var ref1 = (0,react.useState)(null), error = ref1[0], setError = ref1[1];
    var ref2 = (0,react.useState)(null), name = ref2[0], setName = ref2[1];
    var ref3 = (0,react.useState)(null), tokenNumber = ref3[0], setTokenNumber = ref3[1];
    var ref4 = (0,react.useState)(0), waitingAhead = ref4[0], setWaitingAhead = ref4[1];
    var ref5 = (0,react.useState)(null), currentTokenNumber = ref5[0], setCurrentTokenNumber = ref5[1];
    var ref6 = (0,react.useState)(null), businessName = ref6[0], setBusinessName = ref6[1];
    var ref7 = (0,react.useState)(null), clientName = ref7[0], setClientName = ref7[1];
    var ref8 = (0,react.useState)(null), clientQr = ref8[0], setClientQr = ref8[1];
    var ref9 = (0,react.useState)("inactive"), clientStatus = ref9[0], setClientStatus = ref9[1];
    var ref10 = (0,react.useState)(null), waitingTime = ref10[0], setWaitingTime = ref10[1];
    var ref11 = (0,react.useState)(null), consultDate = ref11[0], setConsultDate = ref11[1];
    var ref12 = (0,react.useState)(null), sessionDisplay = ref12[0], setSessionDisplay = ref12[1];
    var ref13 = (0,react.useState)(null), consultationTime = ref13[0], setconsultationTime = ref13[1];
    var ref14 = (0,react.useState)(null), isForToday = ref14[0], setIsForToday = ref14[1];
    var ref15 = (0,react.useState)(false), loading = ref15[0], setLoading = ref15[1];
    (0,react.useEffect)(function() {
        if (props.trackingId) {
            handleRequest();
        }
    }, [
        props.trackingId
    ]);
    var handleRequest = function() {
        setLoading(true);
        axios_default().get("/api/backend/queue/customer/track?t=" + props.trackingId.replace(",", "")).then(function(resp) {
            if (resp.data) {
                console.log(JSON.stringify(resp.data));
                if (resp.data.status != "expired") {
                    setTokenNumber(resp.data.token);
                    setName(resp.data.name);
                    setCurrentTokenNumber(resp.data.currentToken);
                    setWaitingTime(resp.data.estimatedWaitingTime);
                    setWaitingAhead(resp.data.waitingAhead);
                    setBusinessName(resp.data.businessName);
                    setClientName(resp.data.clientName);
                    setClientStatus(resp.data.clientStatus);
                    setClientQr(resp.data.qrCode);
                    setconsultationTime(resp.data.consultationTimeRange);
                    setConsultDate(resp.data.consultDate);
                    setSessionDisplay(resp.data.sessionDisplay);
                    setIsForToday(resp.data.forToday);
                    gtag/* event */.B({
                        action: "status_track",
                        params: {
                            trackingId: props.trackingId,
                            client_qr: clientQr
                        }
                    });
                } else {
                    setError("Tracking URL is expired");
                }
            } else {
                setError("* Something went wrong");
            }
        }).catch(function(err) {
            setError("* Something went wrong");
            console.error(err);
            if (err.response && err.response.status && err.response.status === 403) {
                (0,utils/* handleLogout */.hY)();
            }
        }).finally(function() {
            setLoading(false);
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col col-md-6 offset-md-3 col-lg-6 offset-lg-3 d-grid pt-5",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "card py-lg-5 px-3 px-lg-5 shadow-lg d-none d-md-block",
                            children: getTrackingView()
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "px-3 d-md-none",
                            children: getTrackingView()
                        })
                    ]
                })
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "text-center py-5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "spinner-border",
                    role: "status",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Loading..."
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./pages/t.tsx





var Customer = function(props) {
    var router = (0,next_router.useRouter)();
    var trackingId = router.query["t"] ? router.query["t"].toString() : null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "QMe - Live Patient Tracking"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "QMe - Live Patient Tracking"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: "Token based appointment system, smart queues, queue management system in hospital, hospital information system"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "noindex, nofollow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackingView, {
                    trackingId: trackingId
                })
            })
        ]
    });
};
/* harmony default export */ var t = (Customer);


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9669,9774,2888,179], function() { return __webpack_exec__(69928); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);